export const CustStoreJSONSchema = {
  type: 'object',
  properties: {
    orderLocationId: {
      type: 'string',
      description: 'OD',
    },
    customerGTMU: {
      type: 'string',
    },
    countryISOCode: {
      type: 'string',
    },
  },
}

export const CustStoreJSONUiSchema = {
  type: 'VerticalLayout',
  className: 'identification-filters',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/orderLocationId',
          component: 'ReadOnlyFieldWithJson',
          label: 'Order Location ID',
        },
        {
          type: 'Control',
          scope: '#/properties/customerGTMU',
          component: 'ReadOnlyFieldWithJson',
          label: 'Customer GTMU',
        },
        {
          type: 'Control',
          scope: '#/properties/countryISOCode',
          component: 'ReadOnlyFieldWithJson',
          label: 'Country ISO Code',
        },
      ],
    },
  ],
}
